import React from 'react';
import { Box, Typography, Container, Tab, Tabs } from '@mui/material';
import BarOnboarding from './BarOnboarding';
import BarList from './BarList';

export default function AdminPortal() {
    const [value, setValue] = React.useState(0);

    return (
        <Container maxWidth="lg">
            <Box sx={{ my: 4 }}>
                <Typography variant="h3" component="h1" gutterBottom>
                    Admin Portal
                </Typography>
                
                <Tabs value={value} onChange={(e, newValue) => setValue(newValue)}>
                    <Tab label="Onboard New Bar" />
                    <Tab label="Manage Bars" />
                </Tabs>

                {value === 0 && <BarOnboarding />}
                {value === 1 && <BarList />}
            </Box>
        </Container>
    );
} 